import { API_BASE_URL } from "@kupikupi/brand";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createExpressOrderV2 } from "../endpoints/order";
import type { CreateExpressOrderInput } from "../types/order";

/**
 * `POST /express/create@2` — consolidate the picked stored items into one
 * international waybill. Resolves to the new `expressOrderNo`. On success the
 * warehouse stored list is invalidated (the shipped items leave the bucket) and
 * the per-user statistics refresh (warehouseQuantity ↓, expressOrderQuantity ↑).
 */
export function useCreateExpressOrder(authToken: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: CreateExpressOrderInput) => {
      if (!authToken) throw new Error("NO_TOKEN");
      return createExpressOrderV2({ baseUrl: API_BASE_URL }, authToken, input);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["warehouse", "stored"] });
      qc.invalidateQueries({ queryKey: ["user", "statistics"] });
    },
  });
}
